import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { GetCustomerPartNumbersApiParameter } from "@thos/Services/CustomerPartNumberService";
import { CustomerPartNumber, CustomerPartNumberCollectionModel } from "@thos/Services/ThosApiModels";
import { CustomerPartNumbersState } from "@thos/Store/Data/CustomerPartNumbers/CustomerPartNumbersState";
import { Draft } from "immer";

const initialState: CustomerPartNumbersState = {
    isLoading: {},
    idByProductNumber: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
};

const reducer = {
    "Data/CustomerPartNumbers/BeginLoad": (
        draft: Draft<CustomerPartNumbersState>,
        action: { parameter: GetCustomerPartNumbersApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Data/CustomerPartNumbers/CompleteLoad": (
        draft: Draft<CustomerPartNumbersState>,
        action: { parameter: GetCustomerPartNumbersApiParameter; collection: CustomerPartNumberCollectionModel },
    ) => {
        setDataViewLoaded(
            draft,
            action.parameter,
            action.collection,
            collection => collection.customerPartNumbers!,
            customerPartNumber => storeIdByProductNumber(draft, customerPartNumber),
        );
    },
    "Data/CustomerPartNumbers/Reset": () => {
        return initialState;
    },
};

function storeIdByProductNumber(draft: Draft<CustomerPartNumbersState>, customerPartNumber: CustomerPartNumber) {
    if (customerPartNumber.product.productNumber) {
        draft.idByProductNumber[customerPartNumber.product.productNumber] = customerPartNumber.id;
    }
}

export default createTypedReducerWithImmer(initialState, reducer);
